import { Component, OnInit } from '@angular/core';
import { format, isToday } from 'date-fns';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CarregaService } from '../services/carrega_file/carrega.service';
import { CalculaAproximacaoService } from '../service/calcula-aproximacao.service';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';



@Component({
  selector: 'app-milk-run_sp',
  templateUrl: './milk-run-sp.component.html',
  styleUrls: ['./milk-run-sp.component.css'],
  standalone: false
})
export class MilkRunSPComponent implements OnInit {
  subscription: Subscription | undefined;
  items: any[] = [];
  trips: any[] = [];
  rota: any[] = [];
  tripsReturn: any[] = [];
  itemsAntigo: any[] = [];
  fornecedores: any[] = [];
  posicao: any[] = [];
  sortColumn: string = '';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = false;
  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  searchText: string = '';
  items2: any[] = [ /* Seus itens aqui */];
  private searchTextSubject = new Subject<string>();
  private searchTextSubscription!: Subscription;
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  // urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaTrips: string = 'https://q1ktorqcr3.execute-api.sa-east-1.amazonaws.com/V1/';
  urlSalva: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  queryControlCenter: string = 'controlCenterDB';
  query: string = 'Itens_Jetta';
  query2: string = 'Porta_Rastreando_JSL';
  query3: string = 'Fornecedores_Karrara_Transport';
  query4: string = 'Carriers';
  query5: string = 'tipos_Veiculos_Karrara';
  data: any;
  editMode!: boolean[];
  informationMode!: boolean[];
  address!: string;
  DataAtual: Date = new Date();
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: ''
  };
  dialogOpen!: boolean;
  dialogAddViagem!: boolean;
  janela1!: string;
  janela2!: string;
  janela3!: string;
  janela4!: string;
  editJanela1!: string;
  editJanela2!: string;
  editJanela3!: string;
  editJanela4!: string;
  janelaDestino1!: string;
  janelaDestino2!: string;
  janelaDestino3!: string;
  janelaDestino4!: string;
  editJanelaDestino1!: string;
  editJanelaDestino2!: string;
  editJanelaDestino3!: string;
  editJanelaDestino4!: string;
  carriers!: any[];
  places!: any[];
  transportadora!: string[];
  locais!: string[];
  datePipe: any;
  rastreioAtivo!: boolean;

  progManual: string[] = [
    'PROGRAMAÇÃO TCM - INT',
    'PROGRAMAÇÃO JSL SP',
    'PROGRAMAÇÃO JSL SUL'

  ];
  selectedDescription!: string;
  Transportadoras!: string;
  listaTransportadoras!: any[];
  dataInvertida: string = '';
  fornecedores1!: any[];
  fornecedores2!: any[];
  fornecedores3!: any[];
  fornecedores4!: any[];
  fornecedoresDescarga1!: any[];
  fornecedoresDescarga2!: any[];
  fornecedoresDescarga3!: any[];
  fornecedoresDescarga4!: any[];
  tipoVeiculo!: any[];
  listaVeiculo1!: any[];
  datadescarga!: string | null;
  tipoVeiculos: any;
  isLoading: boolean = true;
  nomeContato!: string;
  telefone!: string;
  filterColumn: string = 'entrada';
  referenceDate!: string;
  numDays: number = 1;
  itemsControlCenter!: any[];
  usuarioLogado: any;
  isAdminEnabled: boolean = false;
  isUserEnabled: boolean = false;
  isCarrierEnabled: boolean = false;
  veiculoEdited: any = {};
  dialogAddDesvio: boolean = false;

  constructor(
    private dynamoDBService: ApiService,
    public dialog: MatDialog,
    private http: HttpClient,
    private carregaService: CarregaService,
    private aproximacaoService: CalculaAproximacaoService,
    private autenticacaoService: AutenticacaoService
  ) {
    this.editMode = [];
    this.informationMode = [];
  }

  async ngOnInit() {
    await this.getUserLogado();
    await this.getItemsFromControlCenter();
    await this.getItemsFromDynamoDB();
    await this.getFornecedoresFromDynamoDB();
    await this.getPosicaoFromDynamoDB();
    await this.getCarriersFromDynamoDB();
    await this.getTipoVeiculoFromDynamoDB();
    await this.armazenarLatitudeEmItems();
    await this.filtra();
    await this.verificaConexaoJanela();
    // await this.verificarChegadaScania();
    await this.verificaAtrasoJanela();
    await this.enableFields();
    this.dataLoaded = true;
    this.isLoading = false;

    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.getItemsFromControlCenter();
      await this.getItemsFromDynamoDB();
      await this.getPosicaoFromDynamoDB();
      await this.armazenarLatitudeEmItems();
      await this.filtra();
      await this.verificaConexaoJanela();
      // await this.verificarChegadaScania();
      await this.verificaAtrasoJanela();
      await this.enableFields();
      this.isLoading = false;
    });
  }

  async update() {
    await this.getItemsFromDynamoDB()
    await this.armazenarLatitudeEmItems();
    await this.filtra();
    await this.verificaConexaoJanela();
    await this.verificaAtrasoJanela();
    await this.enableFields();
    this.isLoading = false;
  }

  async getUserLogado() {
    //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    //console.log(this.usuarioLogado)
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '6' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
      // } else if (this.usuarioLogado.role == '1') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
    // console.log( this.usuarioLogado.role)
    // console.log( this.isAdminEnabled)
  }

  async getItemsFromControlCenter(): Promise<void> {
    // console.log('getItemsFromControlCenter')
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    //console.log(this.referenceDate)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos(this.queryControlCenter, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.itemsControlCenter = items.map(item => ({ ...item, checked: false }));
            this.itemsControlCenter = this.itemsControlCenter.filter(item => item.tipoEntrada == 'Milk Run')
            // console.log(this.itemsControlCenter)
            // this.sortByEntryDateDesc();
            // this.cdr.detectChanges();
            // this.applyFilter(); // Chama this.upDate() após a atribuição de items
            // this.isLoading = false;
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  compararDatas(data1: string, data2: string) {
    const dataFormatada1 = new Date(data1).toLocaleDateString();
    const dataFormatada2 = new Date(data2).toLocaleDateString();
    return dataFormatada1 === dataFormatada2;
  }

  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  async onModelChange() {
    this.veiculoEdited.changed = true;
    this.veiculoEdited.veiculoPerfil = await this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']).perfil;
    this.veiculoEdited.combustivel = await this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']).combustivel;
    this.veiculoEdited.emissao = await this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']).emissoes;
    this.veiculoEdited.consumo = await this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']).consumo;
    this.veiculoEdited.capacidadeVolumetrica = await this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']).volume;
    this.veiculoEdited.capacidadePeso = await this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']).peso;
    this.veiculoEdited.emissaoTotal = (this.item['Total Distance'] * this.item.emissao) / this.item.consumo;
    this.veiculoEdited.pesoLoaded = this.isValorValido(this.item['Weight Loaded']) ? ((this.item['Weight Loaded'] / this.item.capacidadePeso) * 100) : 0;
    this.veiculoEdited.cub = this.isValorValido(this.item.Cubage) ? ((this.item.Cubage / this.item.capacidadeVolumetrica) * 100) : 0;
    this.veiculoEdited.fillingRateMax = Math.max(this.veiculoEdited.pesoLoaded, this.veiculoEdited.cub);
    // console.log(this.tipoVeiculo.find(veiculo => veiculo.modelo == this.item['Transport Type']));
    // console.log(this.veiculoEdited);
  }

  addViagem(item: any): void {
    this.veiculoEdited.changed = false;
    this.item = { ...item };
    if (this.item.ID !== undefined) {
      this.item.lastUpdate = new Date();
    } else {
      this.item.date = new Date();
    }
    // console.log(this.item)
    const dataHoraString1 = item['Janela 1'];
    const dataHoraString2 = item['Janela 2'];
    const dataHoraString3 = item['Janela 3'];
    const dataHoraString4 = item['Janela 4'];
    const dataHoraStringDestino1 = item['JanelaDestino 1'];
    const dataHoraStringDestino2 = item['JanelaDestino 2'];
    const dataHoraStringDestino3 = item['JanelaDestino 3'];
    const dataHoraStringDestino4 = item['JanelaDestino 4'];
    // Extrair a data e a hora da string
    if (dataHoraString1) {
      this.item.dataJanela1 = dataHoraString1.slice(0, 10); // "2024-04-23"
      this.item.horaJanela1 = dataHoraString1.slice(11, 16); // "00:00"
    }
    if (dataHoraString2) {
      this.item.dataJanela2 = dataHoraString2.slice(0, 10); // "2024-04-23"
      this.item.horaJanela2 = dataHoraString2.slice(11, 16); // "00:00"
    }
    if (dataHoraString3) {
      this.item.dataJanela3 = dataHoraString3.slice(0, 10); // "2024-04-23"
      this.item.horaJanela3 = dataHoraString3.slice(11, 16); // "00:00"
    }
    if (dataHoraString4) {
      this.item.dataJanela4 = dataHoraString4.slice(0, 10); // "2024-04-23"
      this.item.horaJanela4 = dataHoraString4.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino1) {
      this.item.dataJanelaDestino1 = dataHoraStringDestino1.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino1 = dataHoraStringDestino1.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino2) {
      this.item.dataJanelaDestino2 = dataHoraStringDestino2.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino2 = dataHoraStringDestino2.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino3) {
      this.item.dataJanelaDestino3 = dataHoraStringDestino3.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino3 = dataHoraStringDestino3.slice(11, 16); // "00:00"
    }
    if (dataHoraStringDestino4) {
      this.item.dataJanelaDestino4 = dataHoraStringDestino4.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaDestino4 = dataHoraStringDestino4.slice(11, 16); // "00:00"
    }

    if (Array.isArray(this.carriers)) {
      this.transportadora = this.carriers.map(carrier => carrier.name);
    }

    if (Array.isArray(this.places)) {
      this.locais = this.places.map(places => places.local);
    }

    if (item.description !== undefined && item.description !== '' && item.description !== null) {
      this.progManual.push(item.description);
    }

    if (item.description && item.description.toLowerCase().includes('TCM')) {
      item.Transportadora = 'TCM';
    }

    if (item.description && item.description.toLowerCase().includes('JSL')) {
      item.Transportadora = 'JSL';
    }
    this.Transportadoras = item.Transportadora;
    this.listaTransportadoras = [this.Transportadoras, ...this.transportadora];

    this.fornecedores1 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.fornecedores2 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.fornecedores3 = this.fornecedores.map(fornecedor => fornecedor.local);
    this.fornecedores4 = this.fornecedores.map(fornecedor => fornecedor.local);

    this.listaVeiculo1 = this.tipoVeiculo.map(item => item.modelo);
    this.listaVeiculo1 = [item['Transport Type'], ...this.listaVeiculo1];

    // this.item['Transport Type'] = item['Transport Type'];

    this.fornecedoresDescarga1 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.fornecedoresDescarga2 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.fornecedoresDescarga3 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);
    this.fornecedoresDescarga4 = this.fornecedores
      .filter(fornecedor => fornecedor.descarga === true)
      .map(fornecedor => fornecedor.local);

    this.dialogAddViagem = true;

  }

  addDesvio(item: any) {
    // console.log(item)
    this.item = { ...item };
    this.dialogAddDesvio = true;
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamoDBService.deleteItem(ID, this.urlSalva, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          this.isLoading = false;
          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  async salvar2(item: any) {
    this.isLoading = true;
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);
      this.item.ID = formattedDate.toString();
    }
    // ver se esta vazio e comparar com janela 1
    this.item = { ...item };
    // console.log(item)
    // console.log(this.item)

    if (this.item.dataJanela1 && this.item.horaJanela1) {
      const dataHoraStringRefeitaJanela1 = `${this.item.dataJanela1}T${this.item.horaJanela1}:00.000Z`;
      const dataHoraJanela1 = new Date(dataHoraStringRefeitaJanela1);
      // console.log(dataHoraStringRefeita1)
      // console.log(dataHora1)
      // console.log(dataHora1.toISOString())
      this.item['Janela 1'] = dataHoraJanela1.toISOString();
    }

    if (this.item.dataJanela2 && this.item.horaJanela2) {
      const dataHoraStringRefeitaJanela2 = `${this.item.dataJanela2}T${this.item.horaJanela2}:00.000Z`;
      const dataHoraJanela2 = new Date(dataHoraStringRefeitaJanela2);
      // console.log(dataHoraStringRefeita1)
      // console.log(dataHora1)
      // console.log(dataHora1.toISOString())
      this.item['Janela 2'] = dataHoraJanela2.toISOString();
    }

    if (this.item.dataJanela3 && this.item.horaJanela3) {
      const dataHoraStringRefeitaJanela3 = `${this.item.dataJanela3}T${this.item.horaJanela3}:00.000Z`;
      const dataHoraJanela3 = new Date(dataHoraStringRefeitaJanela3);
      // console.log(dataHoraStringRefeita1)
      // console.log(dataHora1)
      // console.log(dataHora1.toISOString())
      this.item['Janela 3'] = dataHoraJanela3.toISOString();
    }

    if (this.item.dataJanela4 && this.item.horaJanela4) {
      const dataHoraStringRefeitaJanela4 = `${this.item.dataJanela4}T${this.item.horaJanela4}:00.000Z`;
      const dataHoraJanela4 = new Date(dataHoraStringRefeitaJanela4);
      // console.log(dataHoraStringRefeita1)
      // console.log(dataHora1)
      // console.log(dataHora1.toISOString())
      this.item['Janela 4'] = dataHoraJanela4.toISOString();
    }

    if (this.item.dataJanelaDestino1 && this.item.horaJanelaDestino1) {
      const dataHoraStringRefeita1 = `${this.item.dataJanelaDestino1}T${this.item.horaJanelaDestino1}:00.000Z`;
      const dataHora1 = new Date(dataHoraStringRefeita1);
      // console.log(dataHoraStringRefeita1)
      // console.log(dataHora1)
      // console.log(dataHora1.toISOString())
      this.item['JanelaDestino 1'] = dataHora1.toISOString();
    }

    if (this.item.dataJanelaDestino2 && this.item.horaJanelaDestino2) {
      const dataHoraStringRefeita2 = `${this.item.dataJanelaDestino2}T${this.item.horaJanelaDestino2}:00.000Z`;
      const dataHora2 = new Date(dataHoraStringRefeita2);
      this.item['JanelaDestino 2'] = dataHora2.toISOString();
    }

    if (this.item.dataJanelaDestino3 && this.item.horaJanelaDestino3) {
      const dataHoraStringRefeita3 = `${this.item.dataJanelaDestino3}T${this.item.horaJanelaDestino3}:00.000Z`;
      const dataHora3 = new Date(dataHoraStringRefeita3);
      this.item['JanelaDestino 3'] = dataHora3.toISOString();
    }

    if (this.item.dataJanelaDestino4 && this.item.horaJanelaDestino4) {
      const dataHoraStringRefeita4 = `${this.item.dataJanelaDestino4}T${this.item.horaJanelaDestino4}:00.000Z`;
      const dataHora4 = new Date(dataHoraStringRefeita4);
      this.item['JanelaDestino 4'] = dataHora4.toISOString();
    }

    if (this.item.dataJanelaDestino1Alterada && this.item.horaJanelaDestino1Alterada && (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB'))) {
      this.item['dataAlteradaLCB'] = this.item.dataJanelaDestino1Alterada;
      this.item['horaAlteradaLCB'] = this.item.horaJanelaDestino1Alterada;
    } else if (this.item.dataJanelaDestino1Alterada && this.item.horaJanelaDestino1Alterada && (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA'))) {
      this.item['dataAlteradaSCANIA'] = this.item.dataJanelaDestino1Alterada;
      this.item['horaAlteradaSCANIA'] = this.item.horaJanelaDestino1Alterada;
    }

    if (this.item.dataJanelaDestino2Alterada && this.item.horaJanelaDestino2Alterada && (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB'))) {
      this.item['dataAlteradaLCB'] = this.item.dataJanelaDestino2Alterada;
      this.item['horaAlteradaLCB'] = this.item.horaJanelaDestino2Alterada;
    } else if (this.item.dataJanelaDestino2Alterada && this.item.horaJanelaDestino2Alterada && (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA'))) {
      this.item['dataAlteradaSCANIA'] = this.item.dataJanelaDestino2Alterada;
      this.item['horaAlteradaSCANIA'] = this.item.horaJanelaDestino2Alterada;
    }

    if (this.item.dataJanelaDestino3Alterada && this.item.horaJanelaDestino3Alterada && (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB'))) {
      this.item['dataAlteradaLCB'] = this.item.dataJanelaDestino3Alterada;
      this.item['horaAlteradaLCB'] = this.item.horaJanelaDestino3Alterada;
    } else if (this.item.dataJanelaDestino3Alterada && this.item.horaJanelaDestino3Alterada && (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('SCANIA'))) {
      this.item['dataAlteradaSCANIA'] = this.item.dataJanelaDestino3Alterada;
      this.item['horaAlteradaSCANIA'] = this.item.horaJanelaDestino3Alterada;
    }

    if (this.item.dataJanelaDestino4Alterada && this.item.horaJanelaDestino4Alterada && (item['Destino 4'] && item['Destino 4'].toUpperCase().includes('LCB'))) {
      this.item['dataAlteradaLCB'] = this.item.dataJanelaDestino4Alterada;
      this.item['horaAlteradaLCB'] = this.item.horaJanelaDestino4Alterada;
    } else if (this.item.dataJanelaDestino4Alterada && this.item.horaJanelaDestino4Alterada && (item['Destino 4'] && item['Destino 4'].toUpperCase().includes('SCANIA'))) {
      this.item['dataAlteradaSCANIA'] = this.item.dataJanelaDestino4Alterada;
      this.item['horaAlteradaSCANIA'] = this.item.horaJanelaDestino4Alterada;
    }

    this.item.Passos = 0;

    if (this.item['Fornecedor 1'] !== '' && this.item['Fornecedor 1'] !== null && this.item['Fornecedor 1'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Fornecedor 2'] !== '' && this.item['Fornecedor 2'] !== null && this.item['Fornecedor 2'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Fornecedor 3'] !== '' && this.item['Fornecedor 3'] !== null && this.item['Fornecedor 3'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Fornecedor 4'] !== '' && this.item['Fornecedor 4'] !== null && this.item['Fornecedor 4'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }

    if (this.item['Destino 1'] !== '' && this.item['Destino 1'] !== null && this.item['Destino 1'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Destino 2'] !== '' && this.item['Destino 2'] !== null && this.item['Destino 2'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Destino 3'] !== '' && this.item['Destino 3'] !== null && this.item['Destino 3'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    if (this.item['Destino 4'] !== '' && this.item['Destino 4'] !== null && this.item['Destino 4'] !== undefined) {
      this.item.Passos = this.item.Passos + 1;
    }
    this.item.tableName = this.query
    this.item.userLogado = this.usuarioLogado.id
    this.item.UpdateByUser = this.usuarioLogado.id
    this.item.createdManual = true

    if (this.veiculoEdited.changed) {
      this.item.veiculoPerfil = this.veiculoEdited.veiculoPerfil
      this.item.combustivel = this.veiculoEdited.combustivel
      this.item.emissao = this.veiculoEdited.emissao
      this.item.consumo = this.veiculoEdited.consumo
      this.item.capacidadeVolumetrica = this.veiculoEdited.capacidadeVolumetrica
      this.item.capacidadePeso = this.veiculoEdited.capacidadePeso
      this.item.emissaoTotal = this.veiculoEdited.emissaoTotal
      this.item.pesoLoaded = this.veiculoEdited.pesoLoaded
      this.item.cub = this.veiculoEdited.cub
      this.item.fillingRateMax = this.veiculoEdited.fillingRateMax
    }
    const itemsDataString = JSON.stringify(this.item);
    const modifiedString = itemsDataString.replace(/\\"/g, '"');
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    const modifiedJsonString = JSON.stringify(jsonObject);
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray);
    await this.dynamoDBService.salvar(jsonArray, this.query, this.urlSalva).subscribe(async response => {
      await this.update();
      this.dialogAddViagem = false;
      this.veiculoEdited.changed = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  isISODateValid(dateString: string) {
    // Tenta criar um objeto Date a partir da string
    const date = new Date(dateString);
    // Verifica se o objeto Date é um objeto de data válido e não é NaN
    return !isNaN(date.getTime());
  }

  filtra() {
    // console.log("entrou em filtra")
    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 1']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado1 = true;
      } else {
        item.cadastrado1 = false;
      }
    }
    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 2']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado2 = true;
      } else {
        item.cadastrado2 = false;
      }
    }
    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 3']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado3 = true;
      } else {
        item.cadastrado3 = false;
      }
    }
    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Fornecedor 4']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastrado4 = true;
      } else {
        item.cadastrado4 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 1']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino1 = true;
      } else {
        item.cadastradoDestino1 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 2']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino2 = true;
      } else {
        item.cadastradoDestino2 = false;
      }
    }


    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 3']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino3 = true;
      } else {
        item.cadastradoDestino3 = false;
      }
    }

    for (const item of this.items) {
      // Verifica se 'fornecedor' está presente em this.fornecedores
      const fornecedorEncontrado = this.fornecedores.some(fornecedor => fornecedor['local'] === item['Destino 4']);
      // Se fornecedorEncontrado for verdadeiro, significa que 'fornecedor' está presente
      if (fornecedorEncontrado) {
        // Adiciona a chave 'cadastrado' com o valor true ao objeto item
        item.cadastradoDestino4 = true;
      } else {
        item.cadastradoDestino4 = false;
      }
    }
  }

  toggleEditMode(index: number): void {
    this.editMode[index] = !this.editMode[index];
  }
  toggleInformationMode(index: number): void {
    this.informationMode[index] = !this.informationMode[index];
  }


  getFornecedorKeyByIndex(item: any, index: number): string {
    const fornecedorKeys = this.getKeysByPrefix(item, 'Fornecedor');
    return fornecedorKeys[index - 1];
  }

  getDestinoKeyByIndex(item: any, index: number): string {
    const destinoKeys = this.getKeysByPrefix(item, 'Destino');
    return destinoKeys[index - 1];
  }

  getKeysByPrefix(obj: any, prefix: string): string[] {
    return Object.keys(obj).filter(key => key.startsWith(prefix));
  }

  ngOnDestroy() {
    this.searchTextSubscription?.unsubscribe();
  }

  converterData(stringData: string): string {
    const partes = stringData.split('/');
    const dia = partes[0];
    const mes = partes[1];
    const ano = partes[2];

    return `${ano}-${mes}-${dia}`;
  }

  aplicarFiltroPorData(): void {
    if (this.filtroDataInicio && this.filtroDataTermino) {
      const filtroInicio = new Date(this.filtroDataInicio);
      const filtroTermino = new Date(this.filtroDataTermino);

      this.itemsFiltrados = this.items.filter(item => {
        const dataFormatada = this.converterData(item.ATA);
        const dataItem = new Date(dataFormatada);

        return dataItem >= filtroInicio && dataItem <= filtroTermino;
      });
    } else {
      this.itemsFiltrados = this.items;
    }
  }

  // async getItemsFromDynamoDB(): Promise<void> {
  //   // console.log("entrou em getItemsFromDynamoDB")
  //   try {
  //     const response: any = await new Promise(async (resolve, reject) => {
  //       (await this.dynamoDBService.getItems(this.query, this.urlConsultaTrips,'filtro')).subscribe(
  //         (res: any) => resolve(res),
  //         (error: any) => reject(error)
  //       );
  //     });
  async getItemsFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "Itens_Jetta",
        "searchConditions": [
          { "column": "Finalizada", "word": true, "negate": true },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true },
          // { "column": "description", "word": "JSL", "negate": false },
          // { "column": "description", "word": "jsl", "negate": false },
          { "column": "FinalizadaManual", "word": true, "negate": true },
          // { "column": "ID", "word": "", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = await JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.items = items
            this.items = this.items
              .filter((item: { description: string; }) => item.description && (item.description.includes('JSL') || item.description.toLowerCase().includes('jsl')))
            this.items = this.items
              .filter((item: { Finalizada: string | boolean; }) => item.Finalizada != "True" && item.Finalizada != "true" && item.Finalizada != true) // Novo filtro adicionado
            this.items = this.items
              .filter((item: { FinalizadaManual: boolean; }) => item.FinalizadaManual != true) // Novo filtro adicionado
              // .filter(item => !item.Finalizada) // Novo filtro adicionado
              // .filter((item: { ID: string | string[]; }) => item.ID.includes("6504602857")) // Novo filtro adicionado
              // .filter(item => item.description == "Programação 18/09") // Novo filtro adicionado
              // .filter(item => item['Fornecedor 1'] == "INBRASP - INDÚSTRIA BRASILEIRA DE PLÁSTICO")
              this.items .map((item: { [x: string]: any; date: string | number | Date; }) => {
                const date = new Date(item.date);
                const janela1 = item['Janela 1'];
                let janela1Date = janela1;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janela1))) {
                } else {
                  if (janela1 !== undefined) {
                    const janela1Parts = janela1.split(':');
                    const hours = parseInt(janela1Parts[0], 10);
                    const minutes = parseInt(janela1Parts[1], 10);
                    janela1Date = new Date(item.date);
                    janela1Date.setHours(janela1Date.getHours() + hours);
                    janela1Date.setMinutes(janela1Date.getMinutes() + minutes);
                  }
                }
                const janela2 = item['Janela 2'];
                let janela2Date = janela2;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janela2))) {
                } else {
                  if (janela2 !== undefined) {
                    const janela2Parts = janela2.split(':');
                    const hours = parseInt(janela2Parts[0], 10);
                    const minutes = parseInt(janela2Parts[1], 10);
                    janela2Date = new Date(item.date);
                    janela2Date.setHours(janela2Date.getHours() + hours);
                    janela2Date.setMinutes(janela2Date.getMinutes() + minutes);
                  }
                }
                const janela3 = item['Janela 3'];
                let janela3Date = janela3;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janela3))) {
                } else {
                  if (janela3 !== undefined) {
                    const janela3Parts = janela3.split(':');
                    const hours = parseInt(janela3Parts[0], 10);
                    const minutes = parseInt(janela3Parts[1], 10);
                    janela3Date = new Date(item.date);
                    janela3Date.setHours(janela3Date.getHours() + hours);
                    janela3Date.setMinutes(janela3Date.getMinutes() + minutes);
                  }
                }
                const janela4 = item['Janela 4'];
                let janela4Date = janela4;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janela4))) {
                } else {
                  if (janela4 !== undefined) {
                    const janela4Parts = janela4.split(':');
                    const hours = parseInt(janela4Parts[0], 10);
                    const minutes = parseInt(janela4Parts[1], 10);
                    janela4Date = new Date(item.date);
                    janela4Date.setHours(janela4Date.getHours() + hours);
                    janela4Date.setMinutes(janela4Date.getMinutes() + minutes);
                  }
                }
                const janelaDestino1 = item['JanelaDestino 1'];
                let janelaDestino1Date = janelaDestino1;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janelaDestino1))) {
                } else {
                  if (janelaDestino1 !== undefined) {
                    const janelaDestino1Parts = janelaDestino1.split(':');
                    const hours = parseInt(janelaDestino1Parts[0], 10);
                    const minutes = parseInt(janelaDestino1Parts[1], 10);
                    janelaDestino1Date = new Date(item.date);
                    janelaDestino1Date.setHours(janelaDestino1Date.getHours() + hours);
                    janelaDestino1Date.setMinutes(janelaDestino1Date.getMinutes() + minutes);
                  }
                }
                if (item['dataJanelaDestino1Alterada'] !== undefined) {
                  item['JanelaDestino1Alterada'] = `${item['dataJanelaDestino1Alterada']}T${item['horaJanelaDestino1Alterada']}:00.000Z`;
                  // console.log(item)
                }
                     if (item['Destino 1'] && item['Destino 1'].includes('LCB') && item['dataAlteradaLCB'] !== undefined) {
                  item['JanelaDestino1Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z`;
                  // console.log(item)
                }
                const janelaDestino2 = item['JanelaDestino 2'];
                let janelaDestino2Date = janelaDestino2;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janelaDestino2))) {
                } else {
                  if (janelaDestino2 !== undefined) {
                    const janelaDestino2Parts = janelaDestino2.split(':');
                    const hours = parseInt(janelaDestino2Parts[0], 10);
                    const minutes = parseInt(janelaDestino2Parts[1], 10);
                    janelaDestino2Date = new Date(item.date);
                    janelaDestino2Date.setHours(janelaDestino2Date.getHours() + hours);
                    janelaDestino2Date.setMinutes(janelaDestino2Date.getMinutes() + minutes);
                  }
                }
                if (item['dataJanelaDestino2Alterada'] !== undefined) {
                  item['JanelaDestino2Alterada'] = `${item['dataJanelaDestino2Alterada']}T${item['horaJanelaDestino2Alterada']}:00.000Z`;
                }
                     if (item['Destino 2'] && item['Destino 2'].includes('LCB') && item['dataAlteradaLCB'] !== undefined) {
                  item['JanelaDestino2Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z`;
                  // console.log(item)
                }
                const janelaDestino3 = item['JanelaDestino 3'];
                let janelaDestino3Date = janelaDestino3;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janelaDestino3))) {
                } else {
                  if (janelaDestino3 !== undefined) {
                    const janelaDestino3Parts = janelaDestino3.split(':');
                    const hours = parseInt(janelaDestino3Parts[0], 10);
                    const minutes = parseInt(janelaDestino3Parts[1], 10);
                    janelaDestino3Date = new Date(item.date);
                    janelaDestino3Date.setHours(janelaDestino3Date.getHours() + hours);
                    janelaDestino3Date.setMinutes(janelaDestino3Date.getMinutes() + minutes);
                  }
                }

                if (item['dataJanelaDestino3Alterada'] !== undefined) {
                  item['JanelaDestino3Alterada'] = `${item['dataJanelaDestino3Alterada']}T${item['horaJanelaDestino3Alterada']}:00.000Z`;
                }
                    if (item['Destino 3'] && item['Destino 3'].includes('LCB') && item['dataAlteradaLCB'] !== undefined) {
                  item['JanelaDestino3Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z`;
                  // console.log(item)
                }
                const janelaDestino4 = item['JanelaDestino 4'];
                let janelaDestino4Date = janelaDestino4;
                // Verifica se janela1 é uma data válida
                if (!isNaN(Date.parse(janelaDestino4))) {
                } else {
                  if (janelaDestino4 !== undefined) {
                    const janelaDestino4Parts = janelaDestino4.split(':');
                    const hours = parseInt(janelaDestino4Parts[0], 10);
                    const minutes = parseInt(janelaDestino4Parts[1], 10);
                    janelaDestino4Date = new Date(item.date);
                    janelaDestino4Date.setHours(janelaDestino4Date.getHours() + hours);
                    janelaDestino4Date.setMinutes(janelaDestino4Date.getMinutes() + minutes);
                  }
                }
                if (item['dataJanelaDestino4Alterada'] !== undefined) {
                  item['JanelaDestino4Alterada'] = `${item['dataJanelaDestino4Alterada']}T${item['horaJanelaDestino4Alterada']}:00.000Z`;
                }
                     if (item['Destino 4'] && item['Destino 4'].includes('LCB') && item['dataAlteradaLCB'] !== undefined) {
                  item['JanelaDestino4Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z`;
                  // console.log(item)
                }
                // //console.log("items")
                // //console.log(this.items)
                // //console.log(janela1Date)
                // //console.log(janela2Date)
                // //console.log(janelaDestino3)
                // //console.log(janelaDestino4)
                return {
                  ...item,
                  'Janela 1': janela1Date,
                  'Janela 2': janela2Date,
                  'Janela 3': janela3Date,
                  'Janela 4': janela4Date,
                  'JanelaDestino 1': janelaDestino1Date,
                  'JanelaDestino 2': janelaDestino2Date,
                  'JanelaDestino 3': janelaDestino3Date,
                  classZap: 'laranja-icon',
                  classJanela: 'azul',
                  classJanelaDestino: 'azul',
                  icone: 'zap',
                  // Adicione as outras chaves aqui...
                  checked: false
                };
              });
            // console.log(this.items)
            // //console.log("item diferente de finalizada");
            // //console.log(this.items);
            // Filtra os itens que possuem a chave 'description' com a palavra 'sul'
            // (sem diferenciar maiúsculas de minúsculas), adiciona a chave 'checked' a cada item com valor inicial como false,
            // converte a chave 'date' em um objeto de data utilizando o construtor 'Date',
            // soma o valor das chaves 'Janela 1', 'Janela 2' e assim por diante à data do item e atualiza as respectivas chaves com os resultados
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }



  verificaConexaoJanela() {
    // Obtém a data atual
    const dataAtual = new Date();
    // Subtrai uma hora (3600 segundos * 1000 milissegundos)
    const umaHoraAtras = new Date(dataAtual.getTime() - 3600 * 1000);
    this.items.forEach(item => {
      item['classZap'] = "laranja-icon";
      // Converte o valor de item['Janela 1'] para um objeto Date
      const dataJanela1 = new Date(item['Janela 1']);

      // Compara dataJanela1 com umaHoraAtras e verifica se Conexao não é verdadeiro
      if (dataJanela1 > umaHoraAtras && item['Conexao'] !== true) {
        item['classZap'] = "laranja-icon";
        item['icone'] = "zap-off";
      }
      else if (dataJanela1 > umaHoraAtras && item['Conexao'] == true) {
        item['classZap'] = "green-icon";
        item['icone'] = "zap";
      }
      else if (dataJanela1 < umaHoraAtras && item['Conexao'] !== true) {
        item['classZap'] = "vermelho-icon";
        item['icone'] = "zap-off";
      }
      else if (dataJanela1 < umaHoraAtras && item['Conexao'] == true) {
        item['classZap'] = "blinking-icon";
        item['icone'] = "zap";
      }
    });
  }

  verificaAtrasoJanela() {
    // console.log('verificaConexaoJanela')
    // Obtém a data atual
    const dataAtual = new Date();
    let date1str = '';
    let date2str = '';
    // Subtrai uma hora (3600 segundos * 1000 milissegundos)
    const meiaHoraAtras = new Date(dataAtual.getTime() + 3600 * 1000);
    this.items.forEach(item => {
      for (let i = 1; i < 5; i++) {
        if (item['Janela ' + i]) {
          date1str = item['Janela ' + i].replace("Z", "");
          let dataJanelaAtual = new Date(date1str);
          if (item['cadastrado' + i] === false) {
            item['classJanela' + i] = "background-red";
          } else if (dataJanelaAtual < dataAtual && item['Janela ' + i] && item['cadastrado' + i] === true && (item['Passo Fornecedor' + i] < 1 || !item['Passo Fornecedor' + i])) {
            item['classJanela' + i] = "background-red-yellow";
          } else if (dataJanelaAtual < meiaHoraAtras && item['Janela ' + i] && item['cadastrado' + i] === true && (item['Passo Fornecedor' + i] < 1 || !item['Passo Fornecedor' + i])) {
            item['classJanela' + i] = "background-yellow";
          } else if (dataJanelaAtual > meiaHoraAtras && item['Janela ' + i] && item['cadastrado' + i] === true && (item['Passo Fornecedor' + i] < 1 || !item['Passo Fornecedor' + i])) {
            item['classJanela' + i] = "background-blue";
          } else if (item['cadastrado' + i] === true && item['Passo Fornecedor' + i] >= 1) {
            item['classJanela' + i] = "background-green";
          }
        }

        if (item['JanelaDestino ' + i]) {
          date2str = item['JanelaDestino ' + i].replace("Z", "");
          let dataJanelaDestinoAtual = new Date(date2str);
          if (item['cadastradoDestino' + i] === false) {
            item['classJanelaDestino' + i] = "background-red";
          } else if (dataJanelaDestinoAtual < dataAtual && item['JanelaDestino ' + i] && item['cadastradoDestino' + i] === true && (item['Passo Destino' + i] < 1 || !item['Passo Destino' + i])) {
            item['classJanelaDestino' + i] = "background-red-yellow";
          } else if (dataJanelaDestinoAtual < meiaHoraAtras && item['JanelaDestino ' + i] && item['cadastradoDestino' + i] === true && (item['Passo Destino' + i] < 1 || !item['Passo Destino' + i])) {
            item['classJanelaDestino' + i] = "background-yellow";
          } else if (dataJanelaDestinoAtual > meiaHoraAtras && item['JanelaDestino ' + i] && item['cadastradoDestino' + i] === true && (item['Passo Destino' + i] < 1 || !item['Passo Destino' + i])) {
            item['classJanelaDestino' + i] = "background-blue";
          } else if (item['cadastradoDestino' + i] === true && item['Passo Destino' + i] >= 1) {
            item['classJanelaDestino' + i] = "background-green";
          }
        }
        // console.log(item['classJanela' + i])
        // console.log(item['classJanelaDestino' + i])
      }
    });
  }


  async getFornecedoresFromDynamoDB(): Promise<void> {
    //console.log("entrou em getFornecedoresFromDynamoDB")

    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query3, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            this.fornecedores = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            this.fornecedores = this.fornecedores.sort((a, b) => a.local.localeCompare(b.local));
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPosicaoFromDynamoDB(): Promise<void> {
    // console.log("entrou em getPosicaoFromDynamoDB")
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.posicao = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    //console.log("entrou em getCarriersFromDynamoDB")
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query4, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.carriers = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  async getTipoVeiculoFromDynamoDB(): Promise<void> {
    //console.log("entrou em getTipoVeiculoFromDynamoDB")
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query5, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.tipoVeiculo = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }


  armazenarLatitudeEmItems() {
    // console.log("entrou em armazenarLatitudeEmItems")
    for (let i = 0; i < this.items.length; i++) {
      const plate = this.items[i]['Plate'];
      const matchingPosicao = this.posicao.find(obj => obj['ID'] === plate);
      if (matchingPosicao) {
        this.items[i]['Latitude'] = matchingPosicao['Latitude'];
        this.items[i]['Longitude'] = matchingPosicao['Longitude'];
        this.items[i]['Endereco'] = matchingPosicao['Endereco'];
        this.items[i]['data_atualizacao'] = new Date(matchingPosicao['data_atualizacao']);
        this.items[i]['DataBordo'] = new Date(matchingPosicao['DataBordo']);
      }
      if (this.items[i]['DataBordo'] === undefined) {
        this.items[i]['Conexao'] = false;
      } else {
        this.DataAtual = new Date();
        var outraData = new Date(this.items[i]['DataBordo']);
        // //console.log(this.DataAtual)
        // //console.log(outraData)
        // //console.log(new Date(outraData.setHours(outraData.getHours() + 1)))
        if (new Date(outraData.setHours(outraData.getHours() + 1)) > this.DataAtual) {
          this.items[i]['Conexao'] = true;
        } else {
          this.items[i]['Conexao'] = false;
        }
      }
    }
  }


  async salvarFornecedor() {
    if (this.item.ID === undefined || this.item.ID === '') {
      this.isLoading = true;
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);
      this.item = {
        "ID": formattedDate.toString(),
        "contato": this.item.contato,
        "endereco": this.item.endereco,
        "local": this.item.local,
        "latitude": this.item.latitude,
        "longitude": this.item.longitude,
        "descarga": this.item.descarga,
        "nomeContato": this.item.nomeContato,
        "telefone": this.item.telefone
      }
    }
    this.item.tableName = this.query3
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamoDBService.salvar(jsonArray, this.query3, this.urlSalva).subscribe(async response => {
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
    this.dialogOpen = false;
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogAddViagem = false;
    this.dialogAddDesvio = false;
  }

  editDialog(item: any): void {
    this.item.ID = ''
    this.item.local = item;
    this.item.contato = '';
    this.item.endereco = '';
    this.item.latitude = '';
    this.item.longitude = '';
    this.dialogOpen = true;
  }

  async salvarDesvio(item: any) {
    this.isLoading = true;
    this.item.desvio = true;
    this.item.descricaoDesvio = item.descricaoDesvio;
    this.item.responsavelDesvio = item.responsavelDesvio;
    this.item.respCiente = item.respCiente;
    this.item.reportado = item.reportado;
    this.item.classDesvio = "vermelho-icon";
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamoDBService.salvar(jsonArray, this.query3, this.urlSalva).subscribe(async response => {
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
    this.dialogAddDesvio = false;
  }

  async apagarDesvio(item: any) {
    this.isLoading = true;
    this.item.desvio = false;
    this.item.descricaoDesvio = '';
    this.item.responsavelDesvio = '';
    this.item.respCiente = '';
    this.item.reportado = '';
    this.item.classDesvio = "";
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    //console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamoDBService.salvar(jsonArray, this.query3, this.urlSalva).subscribe(async response => {
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
    this.dialogAddDesvio = false;
  }

  async completaViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      //console.log(item)
      var PassoF: any = []
      var PassoD: any = []
      for (let i = 1; i < 5; i++) {
        if (item['Fornecedor ' + i]) {
          PassoF[i] = 1;
        } else {
          PassoF[i] = 0;
        }
        // //console.log('PassoF[' + i + '] = ' + PassoF[i])
      }
      for (let i = 1; i < 5; i++) {
        if (item['Destino ' + i]) {
          PassoD[i] = 1;
        } else {
          PassoD[i] = 0;
        }
        // //console.log('PassoD[' + i + '] = ' + PassoD[i])
      }

      this.DataAtual.setHours(this.DataAtual.getHours() - 3);

      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "FinalizadaManual": true,
        "FinalizadaByUser": this.usuarioLogado.id,
        "FinalizadaManualDate": this.DataAtual.toISOString(),
        'Passo Fornecedor1': PassoF[1],
        'Passo Fornecedor2': PassoF[2],
        'Passo Fornecedor3': PassoF[3],
        'Passo Fornecedor4': PassoF[4],
        'Passo Destino1': PassoD[1],
        'Passo Destino2': PassoD[2],
        'Passo Destino3': PassoD[3],
        'Passo Destino4': PassoD[4],
      }];

      //nao usa a query, ele manda a time table no item
      await this.dynamoDBService.salvar(body, this.query2, this.urlSalva).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }


  acaoDeClique(item: any, NomePasso: string, NomeBotao: string, NomeDestino: string) {
    // if (item[NomeBotao] === false) {
    //   // Executa ação 1
    //   this.editDialog(item[NomeDestino]);
    // } else {
    // Executa ação 2
    this.finalizaPasso(NomePasso, item);
    // }
  }

  async finalizaPasso(Passo: string, item: any) {
    // Exibe a caixa de diálogo de confirmação
    const confirmacao = window.confirm("Tem certeza que deseja confirmar a coleta neste ponto?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.salvar(Passo, item);

      // Adicione aqui qualquer outra lógica que você deseja executar após salvar o item
    }

  }

  async salvar(Passo: String, item: any): Promise<void> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = [];
    if (Passo == 'Placa') {
      body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "Plate": item.Plate,
      }];

    } else {
      let ValorPasso = 0;
      let ContadorPasso = 0;
      switch (Passo) {
        case 'Passo Fornecedor1':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 1'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Fornecedor2':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 2'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Fornecedor3':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 3'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Fornecedor4':
          ContadorPasso = ContadorPasso + 1;
          if (item['Janela 4'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino1':
          item['FinalizacaoManualDestino1'] = true;
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 1'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino2':
          item['FinalizacaoManualDestino2'] = true;
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 2'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino3':
          item['FinalizacaoManualDestino3'] = true;
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 3'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;
        case 'Passo Destino4':
          item['FinalizacaoManualDestino4'] = true;
          ContadorPasso = ContadorPasso + 1;
          if (item['JanelaDestino 4'] > new Date()) {
            ValorPasso = 1;
          } else {
            ValorPasso = 1;
          }
          break;

      }


      if (item['Passo Fornecedor1'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Fornecedor2'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Fornecedor3'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Fornecedor4'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino1'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino2'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino3'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }
      if (item['Passo Destino4'] > 0) {
        ContadorPasso = ContadorPasso + 1;
      }

      this.DataAtual.setHours(this.DataAtual.getHours() - 3);

      // if (parseInt(item['Passos'], 10) === ContadorPasso) {
      //   body = [{
      //     ...item, // Mantém as chaves existentes
      //     "ID": item.ID,
      //     "FinalizadaManual": true,
      //     "FinalizadaByUser": this.usuarioLogado.id,
      //     "FinalizadaManualDate": this.DataAtual.toISOString(),
      //     [Passo.toString()]: ValorPasso
      //     // Adicione outros campos conforme necessário
      //   }];
      // } else {
      body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        [Passo.toString()]: ValorPasso,
        // Adicione outros campos conforme necessário
      }];
      // }
    }

    await this.dynamoDBService.salvar(body, this.query2, this.urlSalva).subscribe(async response => {
      // Atualiza o item no banco de dados com sucesso
      // //console.log(response)
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
      // Lidar com o erro ao atualizar o item no banco de dados
    });
  }


  getItemAntigo(item: any): number {
    for (let i = 0; i < this.itemsAntigo.length; i++) {
      if (this.itemsAntigo[i].ID === item.ID) {
        return i;
      }
    }
    return -1; // Retorna -1 se não encontrar correspondência
  }



}









